"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var mockAddresses = [
    {
        address: 'Laan van Meerdervoort 61',
        city: "'s-Gravenhage",
        country: 'NL',
        postalCode: '2517AG',
    },
    {
        address: 'Cromhoutlaan 17',
        city: 'RIJSWIJK',
        country: 'NL',
        postalCode: '2283EA',
    },
    {
        address: 'Jule Stynestraat 26',
        city: 'Utrecht',
        country: 'NL',
        postalCode: '3543DR',
    },
    {
        address: 'Oldenzaalsestraat 271',
        city: 'Enschede',
        country: 'NL',
        postalCode: '7523AC',
    },
    {
        address: '`t Kempke 1',
        city: 'WEHL',
        country: 'NL',
        postalCode: '7031AZ',
    },
    {
        address: 'Nancy Zeelenbergsingel 185',
        city: 'Rotterdam',
        country: 'NL',
        postalCode: '3066GA',
    },
    {
        address: 'Jan Evertsenstraat 527',
        city: 'Amsterdam',
        country: 'NL',
        postalCode: '1061XZ',
    },
    {
        address: 'Leyweg 1017',
        city: 'Den Haag',
        country: 'NL',
        postalCode: '2545HE',
    },
    {
        address: 'Kringloop 236',
        city: 'Amstelveen',
        country: 'NL',
        postalCode: '1186HL',
    },
    {
        address: 'Bisonstraat 108',
        city: 'Gemert',
        country: 'NL',
        postalCode: '5421EG',
    },
    {
        address: 'Vlechtbaan 14',
        city: 'Leiderdorp',
        country: 'NL',
        postalCode: '2352DL',
    },
    {
        address: 'robert regoutstraat 18',
        city: 'roermond',
        country: 'NL',
        postalCode: '6042CN',
    },
    {
        address: 'Valeriusstraat 240',
        city: 'Amsterdam',
        country: 'NL',
        postalCode: '1075GL',
    },
    {
        address: 'Ien Dalessingel 295',
        city: 'Zutphen',
        country: 'NL',
        postalCode: '7207LG',
    },
    {
        address: 'Kortricklaan 258',
        city: 'Olst',
        country: 'NL',
        postalCode: '8121GW',
    },
    {
        address: 'Sibeliuspark 761',
        city: 'Oss',
        country: 'NL',
        postalCode: '5343BT',
    },
    {
        address: 'HET PLEIN 130',
        city: 'HENGELO',
        country: 'NL',
        postalCode: '7559SR',
    },
    {
        address: 'Van Heenvlietlaan 232m',
        city: 'Amsterdam',
        country: 'NL',
        postalCode: '1083CN',
    },
    {
        address: 'Biesboschstraat 66',
        city: 'Alkmaar',
        country: 'NL',
        postalCode: '1823WE',
    },
    {
        address: 'Giessenburg 16',
        city: 'Hoofddorp',
        country: 'NL',
        postalCode: '2135EN',
    },
    {
        address: 'Dijkgravenlaan 15',
        city: 'Amstelveen',
        country: 'NL',
        postalCode: '1181PG',
    },
    {
        address: 'Bennebroekstraat 20',
        city: 'TILBURG',
        country: 'NL',
        postalCode: '5043 AC',
    },
    {
        address: 'Purperreiger 86 86',
        city: 'Ouderkerk aan de Amstel',
        country: 'NL',
        postalCode: '1191SN',
    },
    {
        address: 'Vlut 19',
        city: 'Ospel',
        country: 'NL',
        postalCode: '6035PJ',
    },
];
exports.mockShipment = function () {
    return mockAddresses.map(function (address, index) { return ({
        barcode: "test-shipment-" + new Date().getTime() + "-" + index,
        productName: 'SAME_DAY',
        receiver: {
            emailAddress: 'noemail@nodomain.no',
            location: address,
            name: 'John Doe',
            phoneNumber: '+3123456789',
        },
        sender: {
            companyName: 'Trunkrs B.V',
            emailAddress: 'hidde@trunkrs.nl',
            location: {
                address: 'Sportlaan 3A',
                city: 'Vianen',
                country: constants_1.Country.NL,
                postalCode: '4131NN',
            },
            name: 'Hidde Stokvis',
            phoneNumber: '+31639751448',
        },
    }); });
};
